import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const TEASERS = [
  { to: "/pricing", img: "/girl-riding.jpg", alt: "A girl smiling as she rides the toboggan track at Cool Runnings", title: "Tickets & Pricing" },
  { to: "/menu", img: "/products/platter-chicken.jpg", alt: "The Butcher's Board platter with chicken drumsticks and meatballs", title: "Food & Platters" },
  { to: "/events", img: "/park-party.jpg", alt: "A birthday party celebrating at Cool Runnings", title: "Events & Groups" },
  { to: "/times", img: "/park-launch.jpg", alt: "The launch point where every ride starts", title: "Plan Your Visit" },
  { to: "/gallery", img: "/park-bar.jpg", alt: "The licensed bar at the park", title: "Gallery" },
  { to: "/reviews", img: "/park-queue.jpg", alt: "School groups queuing excitedly for their rides", title: "Reviews" },
];

export default function TeaserCards() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6" data-testid="home-teasers-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7 }}
        className="flex flex-wrap items-end justify-between gap-6"
      >
        <div>
          <p className="eyebrow">Explore the park</p>
          <h2 className="mt-3 max-w-2xl text-4xl leading-tight text-[#c87700] drop-shadow-[0_1px_0_rgba(122,86,0,0.6)] sm:text-5xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>PICK YOUR ADVENTURE</h2>
        </div>
        <p className="max-w-sm text-sm font-semibold text-[#8a7b5e]">
          Everything the park offers, one page each — no endless scrolling, just the good stuff.
        </p>
      </motion.div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TEASERS.map((t, i) => (
          <motion.div
            key={t.to}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.55, delay: i * 0.06 }}
            className="card-dark group flex flex-col overflow-hidden transition-all hover:-translate-y-1.5 hover:border-[#f8b818]"
            data-testid={`home-teaser-card-${t.to.replace("/", "")}`}
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={t.img}
                alt={t.alt}
                loading="lazy"
                className="h-full w-full object-cover object-[center_35%] transition-transform duration-700 group-hover:scale-105"
                data-testid={`home-teaser-thumb-${t.to.replace("/", "")}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#241c0d]/25 to-transparent" />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="text-2xl leading-tight text-[#241c0d]" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>{t.title}</h3>
              <Link
                to={t.to}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-extrabold uppercase tracking-wide text-[#c87700] transition-colors hover:text-[#f8b818]"
                data-testid={`home-teaser-link-${t.to.replace("/", "")}`}
              >
                Explore <ArrowUpRight size={15} />
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
